import React, { useEffect, useRef } from 'react'
import { Popper, Paper, MenuList, MenuItem, ClickAwayListener, CircularProgress, Box } from '@material-ui/core'

const AutoCompleteMenu = ({
  anchorEl,
  open,
  suggestions,
  selectedIndex,
  onSelect,
  onClose,
  maxItems = 10,
  isLoading = false,
}) => {
  const menuListRef = useRef(null)

  useEffect(() => {
    if (selectedIndex >= 0 && menuListRef.current) {
      const selectedItem = menuListRef.current.children[selectedIndex]
      if (selectedItem) {
        selectedItem.scrollIntoView({ block: 'nearest' })
      }
    }
  }, [selectedIndex])

  return (
    <ClickAwayListener
      onClickAway={(e) => {
        if (!anchorEl?.contains(e.target)) {
          onClose()
        }
      }}
    >
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        style={{
          zIndex: 1300,
          width: anchorEl?.offsetWidth,
          maxHeight: '300px',
          overflow: 'auto',
        }}
      >
        <Paper elevation={3}>
          <MenuList ref={menuListRef}>
            {isLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                <CircularProgress size={24} />
              </Box>
            ) : (
              suggestions.slice(0, maxItems).map((suggestion, index) => (
                <MenuItem
                  key={suggestion.id || index}
                  selected={index === selectedIndex}
                  onClick={() => {
                    onSelect(suggestion)
                    anchorEl?.focus()
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    maxWidth: '100%',
                  }}
                >
                  <span
                    style={{
                      flex: 1,
                      minWidth: 0,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {suggestion.name}
                  </span>
                  {suggestion.omim && (
                    <Box
                      component="span"
                      sx={{ flexShrink: 0, color: 'text.secondary', fontSize: '0.75rem', fontFamily: 'fontFamilyMono' }}
                    >
                      OMIM:{suggestion.omim}
                    </Box>
                  )}
                </MenuItem>
              ))
            )}
          </MenuList>
        </Paper>
      </Popper>
    </ClickAwayListener>
  )
}

export default AutoCompleteMenu
